// @ts-nocheck
import React from 'react';
import { Container, Row, Col } from 'crehana-ui/GridV2';
import ItemCard from './ItemCard';

const GridItemsList = ({
  items,
  origin,
}: {
  items: any[];
  origin?: string;
}) => {
  return (
    <Container>
      <Row>
        {items.map(el => (
          <Col
            key={`desktop-${origin}${el.originalId}`}
            className="itemcard-wrapper pt-24 pb-24"
            xs={12}
            md={6}
          >
            <ItemCard item={el} origin={origin} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default GridItemsList;
